import 'construct-style-sheets-polyfill'; const styleSheet = new CSSStyleSheet(); styleSheet.replaceSync(`:host {
    color: var(--inv-form-label-color, #6d809c);
    font-family: var(--inv-font-family, 'Inter');
    font-weight: var(--inv-form-label-font-weight, 500);
    font-size: var(--inv-form-label-font-size, 0.8em);
}

label {
    margin-top: var(--inv-form-label-margin-top, 0);
    margin-bottom: var(--inv-form-label-margin-bottom, 0);
    display: block;
    width: 100%;
}
`); export default styleSheet;